import reset from '@/ajax/shop/password/reset';

export default { reset };
